export default {
    label: {

    },
    button: {

    },
    table: {

    },
    paging: {

    }
};